import { useCallback, useEffect, useState } from 'react';
import './styles.css';
import { PlayingCards } from 'lucide-react';
import CardsPage from './Cards/CardsPage';
import { fetchCardTypes } from "./data/data";
const cardTypes = await fetchCardTypes();

const Home = () => {
  /* DATABASE */

  //const [globalData, setGlobalData] = useState([]);
  const [cards, setCards] = useState([]);

  /*const fetchGlobalData = useCallback(() => {
    fetch("/globaldata")
      .then((res) => res.json())
      .then((data) => {
        setGlobalData(data);
      })
      .catch((error) => console.error("Error fetching global data:", error));
  }, []);*/

  const fetchCards = useCallback(() => {
    fetch("/card")
      .then((res) => res.json())
      .then((data) => {
        setCards(data);
      })
      .catch((error) => console.error("Error fetching cards:", error));
  }, []);

  const fetchAll = useCallback(() => {
    //fetchGlobalData();
    fetchCards();
  }, [/*fetchGlobalData,*/fetchCards]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  /* NAVIGATION */

  const pages = [
    { line: 1, name: "Cartes", icon: <PlayingCards size={28} />, pageFile: <CardsPage cards={cards} fetchCards={fetchCards} cardTypes={cardTypes} /> }
    /*{ line: 1, name: "Tâches", icon: <ReceiptText size={30} />, pageFile: <TasksPage tasks={tasks} setTasks={setTasks} fetchTasks={fetchTasks} users={users} fetchUsers={fetchUsers} getRewards={getRewards} fetchMonthlyPoints={fetchMonthlyPoints} fetchGlobalData={fetchGlobalData} /> },
    { line: 1, name: "Plan", icon: <Map size={30} />, pageFile: <PlanPage tasks={tasks.filter(t => t.label==="Plan" && t.state<2)} fetchTasks={fetchTasks} fetchUsers={fetchUsers} getRewards={getRewards} fetchMonthlyPoints={fetchMonthlyPoints} fetchGlobalData={fetchGlobalData} afterVoiceButton={fetchAll} /> },
    { line: 1, name: "Boutique", icon: <CardpingCart size={30} />, pageFile: <CardPage card={card} fetchCard={fetchCard}/> },
    { line: 2, name: "Planning", icon: <Calendar size={30} />, pageFile: <AgendaPage /> },
    { line: 2, name: "Courses", icon: <ScrollText size={30} />, pageFile: <PurchasesPage purchases={purchases} setPurchases={setPurchases} fetchPurchases={fetchPurchases} afterVoiceButton={fetchAll} /> },
    { line: 2, name: "Soundboard", icon: <Speaker size={30} />, pageFile: <SoundboardPage /> },
    { line: 2, name: "Paramètres", icon: <Settings size={30} />, pageFile: <SettingsPage /> }*/
  ];
  const [activePage, setActivePage] = useState("Cartes");
  //const navigate = useNavigate();
  useEffect(() => {window.scrollTo(0,0);}, [activePage]);

  return (
    <div>
      <div>
        {pages.find((page) => (activePage === page.name)).pageFile}
      </div>
      <div className='toolbar-space'></div>
       <div className="toolbar">
        {pages.map((page) => (page.line === 1 &&
          <button
            key={page.name}
            onClick={() => setActivePage(page.name)}
            className={`toolbar-button ${activePage === page.name ? "active" : ""}`}
          >
            <div>
              {page.icon}
              <span>{page.name}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Home;
